import React from "react";
import AddMetodoForm from "./AddMetodoForm";

const AddMetodo = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Metodo"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddMetodoForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddMetodo;
